import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HashRouter } from "react-router-dom";

// Throttle animation frames — *without* breaking callers that rely on RAF
(function () {
  const realRaf = window.requestAnimationFrame.bind(window);
  const realCancel = window.cancelAnimationFrame.bind(window);

  let last = 0;

  window.requestAnimationFrame = (cb) => {
    const now = performance.now();
    const visible = !document.hidden; // true when tab is in front
    const minGap = visible ? 33 : 250; // 30 fps or 4 fps
    const wait = Math.max(0, minGap - (now - last));

    const run = (t) => {
      last = t;
      cb(t);
    };

    // No throttling needed → delegate to the native RAF
    if (wait === 0) {
      return realRaf(run);
    }

    // Throttled path — use setTimeout but still return a numeric handle
    const id = setTimeout(() => run(performance.now()), wait);
    return id;
  };

  // Make sure callers can still cancel the handle we returned
  window.cancelAnimationFrame = (h) => {
    clearTimeout(h);
    realCancel(h);
  };
})();

const rootElement = document.getElementById("root");
ReactDOM.createRoot(rootElement).render(
  <HashRouter>
    <App />
  </HashRouter>
);
